import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "selected", "selectedName", "hiddenInput"]
  static values = { url: String }

  connect() {
    this.timeout = null
  }

  search() {
    clearTimeout(this.timeout)
    
    const query = this.inputTarget.value.trim()
    
    if (query.length < 2) {
      this.hideResults()
      return
    }

    this.timeout = setTimeout(() => {
      this.performSearch(query)
    }, 300)
  }

  async performSearch(query) {
    try {
      const searchUrl = this.inputTarget.dataset.url
      const url = new URL(searchUrl, window.location.origin)
      url.searchParams.append('q', query)
      
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      
      const response = await fetch(url, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': csrfToken
        }
      })
      
      if (response.ok) {
        const users = await response.json()
        this.displayResults(users)
      }
    } catch (error) {
      console.error('Search failed:', error)
    }
  }

  displayResults(users) {
    
    if (users.length === 0) {
      this.resultsTarget.innerHTML = '<div class="px-3 py-2 text-sm text-gray-500">No users found</div>'
      this.showResults()
      return
    }

    const fragment = document.createDocumentFragment()

    users.forEach(user => {
      const item = document.createElement('div')
      item.className = 'cursor-pointer px-3 py-2 hover:bg-gray-100'
      item.dataset.action = 'click->user-search#selectUser'
      item.dataset.userId = user.id
      item.dataset.userName = user.display

      const nameDiv = document.createElement('div')
      nameDiv.className = 'font-medium text-gray-900'
      nameDiv.textContent = user.name

      const emailDiv = document.createElement('div')
      emailDiv.className = 'text-sm text-gray-500'
      emailDiv.textContent = user.email

      item.appendChild(nameDiv)
      item.appendChild(emailDiv)
      fragment.appendChild(item)
    })

    this.resultsTarget.replaceChildren(fragment)
    this.showResults()
  }

  selectUser(event) {
    const userId = event.currentTarget.dataset.userId
    const userName = event.currentTarget.dataset.userName
    
    this.hiddenInputTarget.value = userId
    this.selectedNameTarget.textContent = userName
    this.inputTarget.value = ""
    
    this.hideResults()
    this.showSelected()
  }

  clearSelection() {
    this.hiddenInputTarget.value = ""
    this.selectedNameTarget.textContent = ""
    this.hideSelected()
    this.inputTarget.focus()
  }

  showResults() {
    this.resultsTarget.classList.remove('hidden')
  }

  hideResults() {
    this.resultsTarget.classList.add('hidden')
  }

  showSelected() {
    this.selectedTarget.classList.remove('hidden')
  }

  hideSelected() {
    this.selectedTarget.classList.add('hidden')
  }
}